<template>
  <van-tabbar route inactive-color="#000" active-color="#427AF4">
    <van-tabbar-item v-for="item, index in menues" :key="index" :to="item.url" :dot="item.badge > 0" v-show="getShow(item.jurisdiction)">
      {{ item.name }}
      <template #icon="props">
        <van-icon :name="`ri ri-${item.icon}-${props.active ? 'fill' : 'line'}`" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
name: 'GzFooter',
components: {

},
props: {},
data() {
  return {
    menues: [
      { id: '1', name: '工作台', icon: 'home-5', url: '/home',jurisdiction:'KY,KZ' },
      { id: '2', name: '项目', icon: 'stack', url: '/project',jurisdiction:'KY,KZ' },
      { id: '3', name: '统计', icon: 'bar-chart-2', url: '/statistics',jurisdiction:'LD' },
      { id: '4', name: '消息', icon: 'message-2', url: '/message' ,jurisdiction:'KY,KZ' },
      { id: '4', name: '项目完整率', icon: 'stack', url: '/completenessRate' ,jurisdiction:'LD' },
      { id: '3', name: '5分钟办件', icon: 'stack', url: '/process',jurisdiction:'LD' },
    ]
  }
},
computed: {
  getShow(){
    return function(jurisdiction){
      return jurisdiction.includes(this.$store.state.user.postType)
    }
  }
},
}
</script>
<style lang="less" scoped>
::v-deep{
  .van-tabbar {
    height: 56px;
    filter: drop-shadow(0px -3px 8px rgba(0, 0, 0, 0.12));
  }
  .van-tabbar-item {
      font-size: 10px;
  }
  .van-tabbar-item__icon{
    font-size: 20px;
  }
}
</style>
